export enum SubscriptionRecurrenceType {
    Monthly, Yearly
}